import apiHandler from "../core/apiHandler";
const taxpayerCertificatesApi = apiHandler('taxpayer-certificates');
export default taxpayerCertificatesApi;
